module.exports = __webpack_public_path__ + "img/l_c5.f577216d.png";